<template>
    <div class="el-table-container">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" @submit.native.prevent>
            <el-form-item prop="mingcheng" label="资源名称：">
                <el-input v-model.trim="searchForm.mingcheng" maxlength="50" placeholder="请输入（限50字）" clearable></el-input>
            </el-form-item>
            <el-form-item prop="zhuangtai" label="资源状态：">
                <el-select v-model="searchForm.zhuangtai" placeholder="请选择" clearable filterable>
                    <el-option
                            :key="index"
                            :label="item.basicRange"
                            :value="item.basicRange"
                            v-for="(item, index) in resourceStateOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="delLocal" label="删除位置：">
                <el-select v-model="searchForm.delLocal" placeholder="请选择" clearable filterable>
                    <el-option
                            :key="index"
                            :label="item"
                            :value="item"
                            v-for="(item, index) in delLocalOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="delBy" label="删除人：">
                <el-select v-model="searchForm.delBy" placeholder="请选择" clearable filterable>
                    <el-option
                            :key="item.id"
                            :label="item.createByUserName"
                            :value="item.id"
                            v-for="item in delByOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="basicType" label="删除时间：">
                <el-date-picker v-model="time" type="daterange" value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('recycleBin:restore')" type="primary" size="small"
                           icon="el-icon-refresh-left" @click="del(null, 2)">批量还原
                </el-button>
                <el-button v-if="hasPermission('recycleBin:del')" type="danger" size="small" icon="el-icon-delete"
                           @click="del(null, 1)">批量删除
                </el-button>
            </el-form-item>
        </el-form>
        <div class="tips">
            <el-link class="el-icon-info" type="primary" :underline="false"></el-link>
            已选择{{dataListSelections.length}}项数据  <el-link class="fontSize12 m_l1" type="primary" :underline="false" @click="empty" v-if="dataListSelections.length">清空</el-link>
        </div>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small" height="100%"
                class="table" border ref="multipleTable" row-key='id' @selection-change="selectionChangeHandle" @sort-change="sortChange">
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column prop="delLocal" label="删除位置" show-overflow-tooltip></el-table-column>
            <el-table-column prop="delByUserName" label="删除人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="delDate" label="删除时间" sortable="custom" show-overflow-tooltip></el-table-column>
            <el-table-column prop="mingcheng" label="资源名称" show-overflow-tooltip>
                <template slot-scope="{row}">{{row.jsonData.mingcheng}}</template>
            </el-table-column>
            <el-table-column prop="zhuangtai" label="资源状态" sortable="custom" show-overflow-tooltip>
                <template slot-scope="{row}">{{row.jsonData.zhuangtai}}</template>
            </el-table-column>
            <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button v-if="hasPermission('recycleBin:view')" type="text" size="small"
                               @click="view(scope.row)">详情
                    </el-button>
                    <el-button v-if="hasPermission('recycleBin:del')" type="text" size="small"
                               @click="del(scope.row.id, 1)">删除
                    </el-button>
                    <el-button v-if="hasPermission('recycleBin:restore')" type="text" size="small"
                               @click="del(scope.row.id, 2)">还原
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <ResourceAddEditForm ref="resourceAddEditForm"></ResourceAddEditForm>
    </div>
</template>

<script>
    import ResourceAddEditForm from '@/views/modules/dyygCollect/library/resourceAddEditForm'  // 详情

    export default {
        components: {ResourceAddEditForm},
        data() {
            return {
                searchForm: {
                    mingcheng: '',
                    zhuangtai: '',
                    delLocal: '',
                    delBy: '',
                    delDateStart: '',
                    delDateEnd: '',
                    sortField: '',
                    sortOrder: '',
                    current: 1,
                    size: 20,
                },
                time: [],
                dataList: [],
                total: 0,
                dataListSelections: [],
                loading: false,
                resourceStateOpt: [],
                delLocalOpt: [],
                delByOpt: [],
            }
        },
        mounted() {
            this.getResourceState()
            this.getDelLocal()
            this.getDelBy()
            this.refreshList()
        },
        methods: {
            refreshList(type) {
                if (type == 1) {
                    this.searchForm.current = 1
                }
                this.loading = true
                let p = JSON.parse(JSON.stringify(this.searchForm))
                p.delDateStart = this.time && this.time.length ? this.time[0] : ''
                p.delDateEnd = this.time && this.time.length ? this.time[1] : ''
                this.$axios(this.api.metadata.selectRecycleMetadataDataList, p, 'post').then(data => {
                    if (data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                    } else {
                        this.$message.error('查询失败');
                    }
                    this.loading = false
                })
            },
            // 列表排序
            sortChange(column) {
                this.searchForm.sortField = column.prop
                this.searchForm.sortOrder = column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : '')
                this.refreshList()
            },
            // 获取资源状态
            getResourceState() {
                this.$axios(this.api.metadata.selectMetadataRangesByBasicId + '/1861299418288889859').then(data => {
                    if (data.status) {
                        this.resourceStateOpt = data.data
                    }
                })
            },
            // 获取删除位置
            getDelLocal() {
                this.$axios(this.api.metadata.selectMetadataDataDelLocal).then(data => {
                    if (data.status) {
                        this.delLocalOpt = data.data
                    }
                })
            },
            // 获取删除人
            getDelBy() {
                this.$axios(this.api.metadata.selectMetadataDataDelBy).then(data => {
                    if (data.status) {
                        this.delByOpt = data.data
                    }
                })
            },
            view(row) {
                this.$refs.resourceAddEditForm.init('view', row.id, '', row.basicDataId)
            },
            // 删除 type：1删除、2还原
            del(id, type) {
                let ids = [id];
                if (!id && !this.dataListSelections.length) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                if (!id) {
                    ids = this.dataListSelections.map(item => {
                        return item.id
                    })
                }
                let str = '删除', api = this.api.metadata.realDeleteData, method = 'post'
                if(type == 2) {
                    str = '还原'
                    api = this.api.metadata.restoreData
                }
                this.$confirm(`确定${str}所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios(api, ids, method).then(data => {
                        if (data.status) {
                            this.$message.success(str + '成功')
                            this.refreshList()
                            this.empty()
                        } else {
                            this.$message.error(str + '失败')
                        }
                    })
                })
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 清空
            empty() {
                this.$refs.multipleTable.clearSelection()
            },
            reset() {
                this.time = []
                this.$refs.multipleTable.clearSelection()
                this.$refs.searchForm.resetFields();
                this.refreshList(1)
            }
        }
    }
</script>

<style scoped lang="scss">
    .tips {
        padding: 4px;

        .el-icon-info {
            margin-right: 6px;
        }
    }
</style>
